import { render, staticRenderFns } from "./pptYs.vue?vue&type=template&id=415d4247&"
import script from "./pptYs.vue?vue&type=script&lang=js&"
export * from "./pptYs.vue?vue&type=script&lang=js&"
import style0 from "./pptYs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports